<template>
  <v-row>
    <v-col cols="12" lg="8">
      <a-form ref="form" autocomplete="new-password" @submit="save">
        <v-row no-gutters>
          <v-col cols="12" sm="12" lg="12">
            <ValidationProvider
              v-slot="{ errors }"
              :rules="ruleObject()"
              vid="input.newpassword"
            >
              <v-text-field
                v-model="newpassword"
                :label="$t('Config.UserProfile.ChangePassword.NewPassword')"
                :error-messages="errors"
                :type="inputType"
                :append-icon="showPasswordIcon"
                counter
                @click:append="showNewPassword = !showNewPassword"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="12" lg="12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|password-confirmed:input.newpassword"
              vid="input.confirmpassword"
            >
              <v-text-field
                v-model="confirmpassword"
                :label="$t('Config.UserProfile.ChangePassword.ConfirmPassword')"
                :error-messages="errors"
                :type="inputrepeatedType"
                :append-icon="showRepeatedPasswordIcon"
                counter
                @click:append="showConfirmedPassword = !showConfirmedPassword"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>
        <template v-slot:formButtons>
          <a-btn
            v-t="'Config.UserProfile.ChangePassword.Save'"
            color="primary"
            css-class="float-right ml-3"
            type="submit"
          />
          <a-btn
            v-t="'Config.UserProfile.ChangePassword.Cancel'"
            color="secondary"
            css-class="float-right"
            outlined
            @click="navigateToUserProfile"
          />
        </template>
      </a-form>
    </v-col>
    <v-col cols="12" lg="4" class="d-flex">
      <p-password-policies :policies="passwordPolicies" class="pl-4" />
    </v-col>
  </v-row>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import PasswordPoliciesQuery from "./graphql/PasswordPoliciesQuery.gql";
import Form from "+/components/form/Form";
import Button from "+/components/button/Button";
import SetPasswordMutation from "./graphql/SetPasswordMutation.gql";
import { isPersisEmployee } from "@/config/keycloak/keycloakUser.js";
import { redirectIfNoAccess } from "@/config/router.js";

export default {
  beforeRouteEnter(to, from, next) {
    redirectIfNoAccess(isPersisEmployee(), next);
  },
  components: {
    ValidationProvider,
    "a-btn": Button,
    "a-form": Form
  },
  data: () => ({
    newpassword: "",
    confirmpassword: "",
    passwordPolicies: [],
    showNewPassword: false,
    showConfirmedPassword: false
  }),
  computed: {
    inputType() {
      return this.getInputType(this.showNewPassword);
    },
    inputrepeatedType() {
      return this.getInputType(this.showConfirmedPassword);
    },
    showPasswordIcon() {
      return this.getEyeIcon(this.showNewPassword);
    },
    showRepeatedPasswordIcon() {
      return this.getEyeIcon(this.showConfirmedPassword);
    }
  },
  apollo: {
    $client: "security",
    passwordPolicies: {
      query: PasswordPoliciesQuery
    }
  },
  methods: {
    ruleObject() {
      return {
        required: true,
        "password-policies-respected": this.passwordPolicies
      };
    },
    save() {
      this.$apollo
        .mutate({
          client: "security",
          mutation: SetPasswordMutation,
          variables: {
            input: {
              password: this.newpassword
            }
          }
        })
        .then(response => {
          if (this.$refs.form.setErrorsIfExsists(response)) {
            this.dialog = false;
            const successMessage = this.$t(
              "Config.UserProfile.ChangePassword.ChangeSuccessFeedback"
            );
            this.$feedback(successMessage, {
              type: "success"
            });
            this.navigateToUserProfile();
          }
        });
    },
    getEyeIcon(showPassword) {
      return showPassword ? "mdi-eye" : "mdi-eye-off";
    },
    getInputType(showPassword) {
      return showPassword ? "text" : "password";
    },
    navigateToUserProfile() {
      this.$router.push({ name: "config.userprofile" });
    }
  }
};
</script>
